<div class="bg-primary-800 dark:bg-primary px-12 py-20 md:px-12 lg:px-20">
	<div class="flex flex-col gap-6 md:gap-8">
		<div class="flex flex-col gap-4 items-center text-center">
			<div class="flex flex-col gap-4 w-full lg:w-3/4">
				<app-headline-large
					[title]="content.title"
					class="text-primary-contrast!"></app-headline-large>
				<app-body-large
					[description]="content.description"
					class="text-primary-contrast/75!"></app-body-large>
			</div>
		</div>

		@if (content.copy.length >= 4){
		<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 gap-y-4">
			@for (item of content.copy; track item.title) {
			<div class="flex-1 flex items-center justify-center gap-4 min-h-20">
				<img
					loading="lazy"
					class="object-cover"
					[src]="item.image.src"
					[alt]="item.image.alt" />
				@if (item.title.length > 0){
				<div class="text-primary-contrast text-lg lg:text-xl font-semibold leading-tight">{{ item.title }}</div>
				}
			</div>
			}
		</div>
		} @else {
		<div class="grid grid-cols-1 md:grid-cols-3 gap-4 gap-y-4">
			@for (item of content.copy; track item.title) {
			<div class="flex-1 flex items-center justify-center gap-4 min-h-20">
				<img
					loading="lazy"
					class="object-cover"
					[src]="item.image.src"
					[alt]="item.image.alt" />
				@if (item.title.length > 0){
				<div class="text-primary-contrast text-lg lg:text-xl font-semibold leading-tight">{{ item.title }}</div>
				}
			</div>
			}
		</div>

		}
	</div>
</div>
